module.exports = __webpack_public_path__ + "static/media/shuri-atomi.d4018f29.jpg";